import * as types from 'store/mutation-types'
import api from 'store/api'
import Vue from 'vue'

const _isFalsy = val =>
    _.isNil(val) || _.isEmpty(val) || val == 0 || val === false

const _isValid = val => !_isFalsy(val)

const requestCancel = {
    token: Vue.axios.CancelToken,
    source: null
}

const state = {
    searchFilters: {
        agenciesID: [],
        bookingsDate: 1,
        canceled: 2
    },
    bookings: [],
    dashboardBookings: [],
    bookings_unavailabilities: [],
    requestCancel
}

const mutations = {
    [types.BOOKINGS_RECEIVED](state, payload) {
        state.bookings = payload || []
    },
    [types.BOOKINGS_UNAVAILABILITY_RECEIVED](state, payload) {
        state.bookings_unavailabilities = payload || []
    },
    [types.BOOKINGS_FILTERS_CHANGED](state, value) {
        if (!_.isNil(value)) {
            state.searchFilters.agenciesID = [value[0]]
        }
    },
    [types.BOOKINGS_DATE_FILTER_CHANGED](state, value) {
        if (!_.isNil(value)) {
            state.searchFilters.bookingsDate = value
        }
    },
    [types.BOOKING_CANCELED_FILTER_CHANGED](state, value) {
        if (!_.isNil(value)) {
            state.searchFilters.canceled = value
        }
    },
    [types.DASHBOARD_BOOKINGS_RECEIVED](state, value) {
        state.dashboardBookings = value
    }
}

const actions = {
    fetchPunctualUnavailabiliy({ commit, state}) {
        let period = ''
        if (state.searchFilters.bookingsDate == 1) {
            period = 'ongoing-future'
        } else {
            period = 'past'
        }

        if (!_.isNil(state.searchFilters.agenciesID[0])) {
            return api.fetchPunctualUnavailabiliy({
                paginate: 0,
                'agencies': state.searchFilters.agenciesID,
                period
            }).then((response) => {
                commit(types.BOOKINGS_UNAVAILABILITY_RECEIVED, response.data.punctual_unavailabilities)
            })
        }
    },
    fetchBookings({ commit, state }, { cancel = true }) {
        // canceling any previous & pending AJAX query
        if (cancel) {
            if (!_.isNull(state.requestCancel.source))
                state.requestCancel.source.cancel()
        }
        let token = state.requestCancel.token
        let source = token.source()
        let cancelToken = source.token
        state.requestCancel.source = source

        let period = ''
        if (state.searchFilters.bookingsDate == 1) {
            period = 'ongoing-future'
        } else {
            period = 'past'
        }

        let canceled = ''
        if (state.searchFilters.canceled == 0) { canceled = '0' }
        if (state.searchFilters.canceled == 1) { canceled = '1' }

        return api.fetchBookings({
            'paginate': 0,
            'agencies': state.searchFilters.agenciesID,
            period,
            canceled,
            'with': 'suborder.offer.distributed_product.agency.schedules;suborder.suborderable.customer'
        }, cancelToken).then((response) => {
            commit(types.BOOKINGS_RECEIVED, response.data.bookings)
        })
    },
    updateFilters({ commit, dispatch }, value) {
        commit(types.BOOKINGS_FILTERS_CHANGED, value)
        dispatch('fetchBookings', value)
        dispatch('fetchPunctualUnavailabiliy')
    },
    updateBookingsDateFilter({commit, dispatch}, value) {
        commit(types.BOOKINGS_DATE_FILTER_CHANGED, value)
        dispatch('fetchBookings', value)
        dispatch('fetchPunctualUnavailabiliy')
    },
    updateCanceledFilter({ commit, dispatch }, value) {
        commit(types.BOOKING_CANCELED_FILTER_CHANGED, value)
        dispatch('fetchBookings', value)
    },
    fetchDashboardBookings({ commit, state }, params) {
        return api.fetchBookings(params).then((response) => {
            commit(types.DASHBOARD_BOOKINGS_RECEIVED, response.data.data)
        })
    }
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./client/store/modules/bookings.js